import httpClient from './httpClient';

export const PAYMENT_ENDPOINT = '/backoffice/payment-methods';

/**
 * ดึง list ของ payment method groups (ไม่มี methods ข้างใน)
 * ใช้สำหรับ: dropdown filter ใน Orders.vue, listing ใน Payments.vue
 * รองรับ query param: with_payment_methods=1 เพื่อให้ response มี payment_methods ฝังมาด้วย
 *   → ใช้กับ: PromotionPaymentCondition.vue, FormGetPaymentMethod.vue
 */
export const getPaymentMethodGroupsAPI = (params) => httpClient.get(`${PAYMENT_ENDPOINT}/groups`, { params });

/**
 * ดึง payment method groups ทั้งหมดพร้อม methods และ subgroups ครบใน 1 call
 * ใช้สำหรับ: ShippingPaymentMethodSetting.vue — แทนการยิง N+1 calls แบบเดิม
 * ต่างจาก groups?with_payment_methods=1 ตรงที่มี payment_method_subgroups ด้วย
 */
export const getPaymentMethodGroupsAllAPI = () => httpClient.get(`${PAYMENT_ENDPOINT}/groups-all`);

/**
 * ดึง payment methods แบบ flat list (ไม่จัดกลุ่ม) แต่ละตัวมี payment_method_group back-reference
 * ใช้สำหรับ: PromotionDiscountOnTopPayment.vue — ต้องการ method-level data เพื่อ render label "Group - Method"
 */
export const getPaymentMethodListAPI = () => httpClient.get(`${PAYMENT_ENDPOINT}`);

export const getPaymentMethodAPI = (id) => httpClient.get(`${PAYMENT_ENDPOINT}/${id}`);

/**
 * ดึง detail ของ payment method group รายตัว (มี subgroups, methods, channels ครบ)
 * ใช้สำหรับ: หน้า edit payment group
 * หมายเหตุ: ไม่ควรใช้ใน loop (N+1 problem) — ให้ใช้ getPaymentMethodGroupsAllAPI แทน
 */
export const getPaymentMethodGroupAPI = (id) => httpClient.get(`${PAYMENT_ENDPOINT}/groups/${id}`);
export const updatePaymentMethodAPI = (id, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${id}`, params);
export const updatePaymentMethodGroupAPI = (id, params) => httpClient.put(`${PAYMENT_ENDPOINT}/groups/${id}`, params);

// Installment
export const createInstallmentPlanAPI = (methodId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/installment-plans`, params);
export const getInstallmentPlansAPI = (methodId, params) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/installment-plans`, { params });
export const getInstallmentPlanAPI = (methodId, planId) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/installment-plans/${planId}`);
export const updateInstallmentPlanAPI = (methodId, planId, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/installment-plans/${planId}`, params);
export const deleteInstallmentPlanAPI = (methodId, planId) => httpClient.delete(`${PAYMENT_ENDPOINT}/${methodId}/installment-plans/${planId}`);

// Installment plan group
export const createInstallmentPlanGroupAPI = (methodId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups`, params);
export const getInstallmentPlanGroupAPI = (methodId, brandId) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}`);
export const updateInstallmentPlanGroupAPI = (methodId, brandId, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}`, params);
export const deleteInstallmentPlanGroupAPI = (methodId, brandId) => httpClient.delete(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}`);

// Installment plan for group
export const createInstallmentPlanForGroupAPI = (methodId, brandId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}/installment-plans`, params);
export const getInstallmentPlanForGroupAPI = (methodId, brandId, planId) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}/installment-plans/${planId}`);
export const updateInstallmentPlanForGroupAPI = (methodId, brandId, planId, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/installment-plan-groups/${brandId}/installment-plans/${planId}`, params);

// Create channel in installment (other bank)
export const createInstallmentPlanChannelAPI = (methodId, channelId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/channels/${channelId}/installment-plans`, params);
export const updateInstallmentPlanChannelAPI = (methodId, channelId, planId, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/channels/${channelId}/installment-plans/${planId}`, params);

// Bank Channel
export const createBankChannelAPI = (methodId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/channels`, params);
export const getBankChannelAPI = (methodId, channel) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/channels/${channel}`);
export const updateBankChannelAPI = (methodId, channel, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/channels/${channel}`, params);
export const deleteBankChannelAPI = (methodId, channel) => httpClient.delete(`${PAYMENT_ENDPOINT}/${methodId}/channels/${channel}`);

// KTC forever plan
export const getForeverPlanAPI = (methodId, planId) => httpClient.get(`${PAYMENT_ENDPOINT}/${methodId}/forever-plans/${planId}`);
export const createForeverPlanAPI = (methodId, params) => httpClient.post(`${PAYMENT_ENDPOINT}/${methodId}/forever-plans`, params);
export const updateForeverPlanAPI = (methodId, planId, params) => httpClient.put(`${PAYMENT_ENDPOINT}/${methodId}/forever-plans/${planId}`, params);
export const deleteForeverPlanAPI = (methodId, planId) => httpClient.delete(`${PAYMENT_ENDPOINT}/${methodId}/forever-plans/${planId}`);